(function () {
    "use strict";

    if ($ && $.fn) {
        $.fn.solovisTooltip = function (options) {
            if (options === "destroy") {
                Solovis.UI.Tooltip.destroyTooltipOnElement(this);
                return null;
            }

            else {
                return this.each(function (index, element) {
                    Solovis.UI.Tooltip.create({
                        element: $(element),
                        text: options.text,
                        html: options.html,
                        delay: options.delay,
                        placement: options.placement,
                        trigger: options.trigger
                    });

                });
            }
        }
    }
})();